import { createGeneralSelectors } from '../_common/selectors';

const getTaskSlice = state => state.task;
export const { getById, getIds, makeGetByQuery } = createGeneralSelectors(getTaskSlice);
